export default "﻿<div>\n    <table data-dojo-attach-point=\"tableContainer\" class=\"SOV_costEntryTable\">\n\n    </table>\n</div>"